import { ButtonBase } from '../../../ButtonBase';

export type CarouselDotButtonProps = {
    index: number;
    isSelected: boolean;
    isSmall: boolean;
    isVisible: boolean;
    onClick: () => void;
};

export function CarouselDotButton({
    index,
    isSelected,
    isSmall,
    isVisible,
    onClick,
}: Readonly<CarouselDotButtonProps>): React.JSX.Element {
    return (
        <ButtonBase
            aria-label={`Go to slide ${index + 1}`}
            aria-current={isSelected ? 'true' : undefined}
            tabIndex={isVisible ? 0 : -1} // only visible dots are tabbable
            onClick={onClick}
            data-carousel-dot={true}
            data-selected={isSelected || undefined}
            data-small={isSmall || undefined}
        />
    );
}
